export const domainForm = {
  table: "v_domains",
  required: ["domain_name"],
  labels: {
    domain_name: "Name",
    domain_enabled: "Enabled",
    domain_description: "Description",
  },
  types: {
    domain_enabled: "boolean",
  },
  defaults: {
    domain_enabled: true,
  },
};

export const domainSettingsForm = {
  table: "v_domain_settings",
  required: ["domain_setting_category", "domain_setting_subcategory", "domain_setting_name"],

  types: {
    domain_setting_enabled: "boolean",
    domain_setting_name: "select",
  },

  labels: {
    domain_setting_category: "Category",
    domain_setting_subcategory: "Subcategory",
    domain_setting_name: "Type",
    domain_setting_value: "Value",
    domain_setting_enabled: "Enabled",
    domain_setting_description: "Description",
  },

  options: {
    domain_setting_name: [
      "Array",
      "Boolean",
      "Code",
      "Dir",
      "Name",
      "Numeric",
      "Text",
      "UUID",
    ],
  },

  defaults: {
    domain_setting_enabled: true,
    domain_setting_order: 0,
  },
};

export const defaultSettingsForm = {
  table: "v_default_settings",
  required: ["default_setting_category", "default_setting_subcategory", "default_setting_name"],
  groupBy: "default_setting_category",
  labels: {
    default_setting_category: "Category",
    default_setting_subcategory: "Subcategory",
    default_setting_name: "Type",
    default_setting_value: "Value",
    default_setting_enabled: "Enabled",
    default_setting_description: "Description",
  },
  types: {
    default_setting_enabled: "boolean",
    default_setting_name: "select",
  },
  options: {
    default_setting_name: [
      "array",
      "boolean",
      "code",
      "dir",
      "name",
      "numeric",
      "text",
      "uuid",
    ],
  },
  defaults: {
    default_setting_enabled: true,
    default_setting_order: 0,
  },
};

export const varsForm = {
  table: "v_vars",
  required: ["var_category", "var_name"],
  groupBy: "var_category",
  labels: {
    var_category: "Category",
    var_name: "Name",
    var_value: "Value",
    var_command: "Command",
    var_hostname: "Hostname",
    var_enabled: "Enabled",
    var_order: "Order",
    var_description: "Description",
  },
  types: {
    var_category: "select",
    var_enabled: "boolean",
    var_command: "select",
    var_order: "select",
  },
  options: {
    var_category: [
      "Codecs",
      "Defaults",
      "IP Address",
      "Music on Hold",
      "Ringtones",
      "Security",
      "SIP",
      "SIP Profile: External",
      "SIP Profile: Internal",
      "Sound",
      "Tones",
      "XMPP",
    ],
    var_command: [
      { label: "Set", value: "set" },
      { label: "Execute & Set", value: "exec-set" },
    ],
    var_order: Array.from({ length: 1000 }, (_, i) => i),
  },
  defaults: {
    var_enabled: true,
    var_order: 0,
  },
};

export const sipProfileForm = {
  table: "v_sip_profiles",
  required: ["sip_profile_name", "sip_profile_description"],

  labels: {
    // Basic Info
    sip_profile_name: "Name",
    sip_profile_hostname: "Hostname",
    sip_profile_enabled: "Enabled",
    sip_profile_description: "Description",

    // Domains
    sip_profile_domain_name: "Domain Name",
    sip_profile_domain_alias: "Domain Alias",
    sip_profile_domain_parse: "Parse Domain",

    // Settings
    sip_profile_setting_name: "Setting Name",
    sip_profile_setting_value: "Value",
    sip_profile_setting_enabled: "Enabled",
    sip_profile_setting_description: "Description",
  },

  sections: {
    "Basic Info": [
      "sip_profile_name",
      "sip_profile_hostname",
      "sip_profile_enabled",
      "sip_profile_description",
    ],
    "Domains": [
      "sip_profile_domain_name",
      "sip_profile_domain_alias",
      "sip_profile_domain_parse",
    ],
    "Settings": [
      "sip_profile_setting_name",
      "sip_profile_setting_value",
      "sip_profile_setting_enabled",
      "sip_profile_setting_description",
    ],
  },

  types: {
    sip_profile_enabled: "boolean",
    sip_profile_domain_parse: "boolean",
    sip_profile_setting_enabled: "boolean",
    sip_profile_domain_alias: "boolean",
  },

  defaults: {
    sip_profile_enabled: "true",
    sip_profile_domain_parse: "false",
    sip_profile_setting_enabled: "true",
    sip_profile_domain_alias: "false",

  },

  requiredSections: {
    Domains: ["sip_profile_domain_name"],
    Settings: ["sip_profile_setting_name"],
  },
};

export const sofiaGlobalSettingsForm = {
  table: "v_sofia_global_settings",
  required: ["sofia_global_setting_name", "sofia_global_setting_value"],

  labels: {
    sofia_global_setting_name: "Name",
    sofia_global_setting_value: "Value",
    sofia_global_setting_enabled: "Enabled",
    sofia_global_setting_description: "Description",
  },

  types: {
    sofia_global_setting_enabled: "boolean",
  },

  defaults: {
    sofia_global_setting_enabled: "true",
  },

  requiredSections: {
    "Sofia Global Settings": [
      "sofia_global_setting_name",
      "sofia_global_setting_value",
    ],
  },
};

export const modulesForm = {
  table: "v_modules",

  required: ["module_label", "module_name", "module_category"],

  groupBy: "module_category",

  labels: {
    module_label: "Label",
    module_name: "Module Name",
    module_order: "Order",
    module_category: "Module Category",
    module_enabled: "Enabled",
    module_default_enabled: "Default Enabled",
    module_description: "Description",
  },

  types: {
    module_enabled: "boolean",
    module_default_enabled: "boolean",
    module_category: "select",
    module_order: "select",
  },

  options: {
    module_category: [
      "Applications",
      "Codecs",
      "Databases",
      "Dialplan Interfaces",
      "Endpoints",
      "Event Handlers",
      "File Format Interfaces",
      "Formats",
      "Languages",
      "Loggers",
      "Say",
      "Streams / Files",
      "XML Interfaces",
    ],
    module_order: Array.from({ length: 1000 }, (_, i) => i),
  },

  defaults: {
    module_enabled: true,
    module_default_enabled: true,
    module_order: 0,
  },
};

export const accessControlForm = {
  table: "v_access_controls",
  required: ["access_control_name"],

  labels: {
    // Basic Info
    access_control_name: "Name",
    access_control_default: "Default",
    access_control_description: "Description",

    // Nodes
    node_type: "Type",
    node_cidr: "CIDR",
    node_description: "Description",
  },

  sections: {
    "Basic Info": [
      "access_control_name",
      "access_control_default",
      "access_control_description",
    ],
    "Nodes": [
      "node_type",
      "node_cidr",
      "node_description",
    ],
  },

  types: {
    access_control_default: "select",
    node_type: "select"
  },

  options: {
    access_control_default: ["allow", "deny"],
    node_type: ["allow", "deny"]
  },

  defaults: {
    access_control_default: "deny",
  },

  requiredSections: {
    "Nodes": ["node_type", "node_cidr"],
  },
};

export const emailTemplatesForm = {
  table: "v_email_templates",
  required: [
    "template_category",
    "template_body",
    "template_subject",
  ],

  types: {
    template_enabled: "boolean",
    template_type: "select",
    domain_uuid: "select",
    template_body: "textarea"
  },

  labels: {
    template_category: "Category",
    template_subcategory: "Subcategory",
    template_subject: "Subject",
    template_body: "Body",
    domain_uuid: "Domain",
    template_type: "Type",
    template_enabled: "Enabled",
    template_description: "Description",
  },

  options: {
    template_type: [
      { label: "HTML", value: "html" },
      { label: "TEXT", value: "text" }
    ],
  },

  var_command: [
    { label: "Set", value: "set" },
    { label: "Execute & Set", value: "exec-set" },
  ],

  defaults: {
    template_enabled: "true",
  },

  sections: {
    "Basic Info": [
      "template_category",
      "template_subcategory",
      "template_subject",
      "template_body",
      "domain_uuid",
      "template_type",
      "template_enabled",
      "template_description"
    ],
  },
};

/* ---------------------- Databases Form ---------------------- */
export const databasesForm = {
  table: "v_databases",
  required: [
    "database_driver",
    "database_type",
    "database_host",
    "database_name",
    "database_port"
  ],
  labels: {
    database_driver: "Driver",
    database_type: "Type",
    database_host: "Host",
    database_port: "Port",
    database_name: "Name",
    database_username: "Username",
    database_password: "Password",
    database_path: "Path",
    database_description: "Description",
  },
  types: {
    database_driver: "select",
    database_type: "select",
    database_port: "number",
  },
  options: {
    database_driver: [
      { label: "PostgreSQL", value: "pgsql" },
      { label: "MySQL", value: "mysql" },
      { label: "SQLite", value: "sqlite" },
      { label: "ODBC", value: "odbc" },
    ],
    database_type: [
      { label: "PostgreSQL", value: "pgsql" },
      { label: "MySQL", value: "mysql" },
      { label: "SQLite", value: "sqlite" },
      { label: "Microsoft SQL Server", value: "mssql" },
    ],
  },
};

export const numberTranslationForm = {
  table: "v_number_translations",
  required: ["number_translation_name"],

  labels: {
    // Basic Info
    number_translation_name: "Name",
    number_translation_enabled: "Enabled",
    number_translation_description: "Description",

    // Details
    number_translation_detail_regex: "Regular Expression",
    number_translation_detail_replace: "Replace",
    number_translation_detail_order: "Order",
  },

  sections: {
    "Basic Info": [
      "number_translation_name",
      "number_translation_enabled",
      "number_translation_description",
    ],

    "Details": [
      "number_translation_detail_regex",
      "number_translation_detail_replace",
      "number_translation_detail_order",
    ],
  },

  types: {
    number_translation_enabled: "boolean",
    number_translation_detail_order: "select",
  },

  options: {
    number_translation_detail_order: Array.from({ length: 999 }, (_, i) => String(i + 1)),
  },

  defaults: {
    number_translation_enabled: "false",
    number_translation_order: "000",
  },

  requiredSections: {
    "Details": ["number_translation_detail_regex"],
  },
};
